module.exports = __webpack_public_path__ + "img/__icon_DŁUŻYCA.bb29625f.svg";